let _ = require("underscore");
let Backbone = require("backbone");

let main = function (_, Backbone) {
    return Backbone.Model.extend({
        defaults: {
            name: null
        }
    });
};

let exportedValue = main(_, Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/MenuTagModel.js